"use strict";

exports.__esModule = true;
exports.ConditionClassify = void 0;
var _Selector = require("../../../Core/Selector");
var _TranslatorContext = require("../../../Core/Translator/TranslatorContext");
var _react = _interopRequireWildcard(require("react"));
var _CommonValidators = require("../../utils/CommonValidators");
var _styles = require("../../styles");
var _Condition = require("../../Condition");
var _vimanaTypes = require("@vimana/vimana-types");
var _ConditionLevels = require("./ConditionLevels");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function validateConditionClassify(condition) {
  var result = condition.conditionType || condition.nativeCode || condition.conditionText;
  return result;
}
var ConditionClassify = exports.ConditionClassify = function ConditionClassify(_ref) {
  var _conditionClassify$co;
  var condition = _ref.condition,
    updateCondition = _ref.updateSelf;
  var _condition$conditionC = condition.conditionClassify,
    conditionClassify = _condition$conditionC === void 0 ? {
      conditionLevel: _ConditionLevels.ConditionLevels[0]
    } : _condition$conditionC;
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  (0, _react.useEffect)(function () {
    return updateSelf(conditionClassify);
  }, []);
  var updateSelf = function updateSelf(conditionClassify) {
    return updateCondition(Object.assign({}, condition, {
      conditionClassify: conditionClassify
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.FlexRow, null, /*#__PURE__*/_react["default"].createElement("span", null, translate("EnrichEditorUI.ConditionClassify.ConditionLevel", "Condition level")), /*#__PURE__*/_react["default"].createElement(_styles.Spacer, null), /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({}, !(0, _CommonValidators.validateSelector)(conditionClassify == null || (_conditionClassify$co = conditionClassify.conditionLevel) == null ? void 0 : _conditionClassify$co.value) && {
    style: Object.assign({}, true && {
      border: "solid 1px red"
    })
  }, {
    dataTestId: "EnrichEditorUI.ConditionClassify.ConditionLevel",
    items: _ConditionLevels.ConditionLevels,
    selected: conditionClassify.conditionLevel != null ? [conditionClassify.conditionLevel] : [],
    getKey: function getKey(conditionLevel) {
      return conditionLevel.value;
    },
    renderItemText: function renderItemText(conditionLevel) {
      return conditionLevel == null ? void 0 : conditionLevel.displayName;
    },
    onSelect: function onSelect(_ref2) {
      var conditionLevel = _ref2[0];
      return updateSelf(Object.assign({}, conditionClassify, {
        conditionLevel: conditionLevel
      }));
    },
    itemPredicate: function itemPredicate(query, item) {
      return item.value.toLowerCase().indexOf(query.toLowerCase()) !== -1 || item.displayName.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    }
  }))), /*#__PURE__*/_react["default"].createElement(_Condition.ConditionTypeFilter, {
    isOpen: conditionClassify.conditionType,
    setOpen: function setOpen(conditionType) {
      return updateSelf(conditionClassify.conditionTypeDataItems ? Object.assign({}, conditionClassify, {
        conditionType: conditionType
      }) : Object.assign({}, conditionClassify, {
        conditionType: conditionType,
        conditionTypeDataItems: [{}]
      }));
    },
    dataItems: conditionClassify.conditionTypeDataItems || [{}],
    setDataItems: function setDataItems(conditionTypeDataItems) {
      return updateSelf(Object.assign({}, conditionClassify, {
        conditionTypeDataItems: conditionTypeDataItems
      }));
    },
    operator: conditionClassify.conditionTypeOperator,
    setOperator: function setOperator(conditionTypeOperator) {
      return updateSelf(Object.assign({}, conditionClassify, {
        conditionTypeOperator: conditionTypeOperator
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_Condition.NativeCodeFilter, {
    isOpen: conditionClassify.nativeCode,
    setOpen: function setOpen(nativeCode) {
      return updateSelf(conditionClassify.nativeCodeValues ? Object.assign({}, conditionClassify, {
        nativeCode: nativeCode
      }) : Object.assign({}, conditionClassify, {
        nativeCode: nativeCode,
        nativeCodeValues: [""]
      }));
    },
    values: conditionClassify.nativeCodeValues,
    setValues: function setValues(nativeCodeValues) {
      return updateSelf(Object.assign({}, conditionClassify, {
        nativeCodeValues: nativeCodeValues
      }));
    },
    operator: conditionClassify.nativeCodeOperator,
    setOperator: function setOperator(nativeCodeOperator) {
      return updateSelf(Object.assign({}, conditionClassify, {
        nativeCodeOperator: nativeCodeOperator
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_Condition.ConditionTextFilter, {
    isOpen: conditionClassify.conditionText,
    setOpen: function setOpen(conditionText) {
      return updateSelf(conditionClassify.conditionTextValues ? Object.assign({}, conditionClassify, {
        conditionText: conditionText
      }) : Object.assign({}, conditionClassify, {
        conditionText: conditionText,
        conditionTextValues: [""]
      }));
    },
    values: conditionClassify.conditionTextValues,
    setValues: function setValues(conditionTextValues) {
      return updateSelf(Object.assign({}, conditionClassify, {
        conditionTextValues: conditionTextValues
      }));
    },
    operator: conditionClassify.conditionTextOperator,
    setOperator: function setOperator(conditionTextOperator) {
      return updateSelf(Object.assign({}, conditionClassify, {
        conditionTextOperator: conditionTextOperator
      }));
    }
  }), !validateConditionClassify(conditionClassify) ? /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: "rgb(194, 48, 48)"
    }
  }, translate("EnrichEditorUI.ClassifyConfig.Validation.FilterRequired", "At least one type of filters is required")) : null);
};